import * as api from '@/api/organizations';
import store from '@/store';

export default {
    namespaced: true,
    state: {
        organizations: [],
        meta: {},
        isFetching: false
    },
    mutations: {
        ADD_ORGANIZATIONS(state, payload){
            state.organizations.push(...payload);
        },
        SET_META(state, payload){
            state.meta = payload;
        },
        CLEAR(state){
            state.organizations.splice(0, state.organizations.length);
            state.meta = {};
        },
        SET_FETCHING(state, payload){
            state.isFetching = payload;
        }
    },
    actions: {
        async LOAD({ commit }, params = {}){
            commit('SET_FETCHING', true);
            try{
                let {data} = await api.workspaceOrganizations(store.getters['workspace/ID_WORK_SPACE'], params);
                commit('CLEAR', data.data);
                commit('ADD_ORGANIZATIONS', data.data);
                commit('SET_META', {...data, data: null});
            }catch(err){
                console.log(err);
            }finally{
                commit('SET_FETCHING', false);
            }
        },
        async LOAD_MORE({ getters, dispatch }){
            if(getters.HAS_LOAD_MORE){
                await dispatch('LOAD', {page: getters.META.current_page + 1});
            }
        },
        async LOAD_PREV({ getters, dispatch }){
            if(getters.HAS_LOAD_PREV){
                await dispatch('LOAD', {page: getters.META.current_page - 1});
            }
        },
        async RELOAD({ dispatch }){
            dispatch('CLEAR');
            dispatch('LOAD');
        },
        CLEAR({ commit }){
            commit('CLEAR');
        }
    },
    getters: {
        IS_LOADED(state){
            return state.isFetching && Object.keys(state.meta).length > 0;
        },
        ORGANIZATIONS(state){
            return state.organizations;
        },
        IS_FETCHING(state){
            return state.isFetching;
        },
        META(state){
            return state.meta;
        },
        HAS_LOAD_MORE(state){
            return state.meta.current_page && state.meta.next_page_url !== null;
        },
        HAS_LOAD_PREV(state){
            return state.meta.current_page && state.meta.prev_page_url !== null;
        }
    },
  }